export default __webpack_public_path__ + "static/media/C.02c31922.svg";